import request from '@/api/request'
import Qs from 'qs'
import { isAndroidIos,isAndroid} from '@/utils/validate'

// 是否实名认证 是否填过表单 是否OCR 是否活体检测
export const appConfigStatus = (params) => {
    return request({
        url: '/v5/appConfig/status',
        method: 'get',
        params
    })
}
// 会员状态
export const vipStatus = (params) => {
    return request({
        url: '/v5/vip/vipStatus',
        method: 'get',
        params
    })
}

// 会员权益使用情况
export const vipRightsUse = (params) => {
  return request({
      url: '/v5/vip/rights',
      method: 'get',
      params
  })
}
// 会员模型分查询
export const creditScore = (params) => {
  return request({
      url: '/v5/vip/creditScore',
      method: 'get',
      params
  })
}
// 会员百融多头风险查询接口
export const vipRiskQuery = (params) => {
  return request({
      url: '/v5/vip/risk',
      method: 'get',
      params
  })
}

// 用户基础信息保存2
export const userBaseInfo2 = (params) => {
  return request({
    url: '/v5/userInfo/userBaseInfo2',
    method: 'get',
    params
  })
}
// 查询用户基本信息
export const queryBaseInfo = (params) => {
  return request({
    url: '/v5/userInfo/queryBaseInfo',
    method: 'get',
    params
  })
}
// 卡片接口
export const appConfigcard = (params) => {
  return request({
    url: '/v5/appConfig/card',
    method: 'get',
    params:{
      ...params
    }
  })
}
// 撞库 P0
export const matchp0 = (params) => {
  return request({
    url: '/v5/match/p0',
    method: 'get',
    params:{
      ...params
    }
  })
}
// 撞库速贷
export const matchsudai = (params) => {
  return request({
    url: '/v5/match/sudai',
    method: 'get',
    params
  })
}


// 撞库P2
export const matchp2 = (params) => {
  return request({
    url: '/v5/match/p2',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
      ...params
    }
  })
}
// 撞库P4
export const matchp4 = (params) => {
  return request({
    url: '/v5/match/p4',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
      ...params
    }
  })
}


// p0进件
export const applyp0 = (params) => {
  return request({
    url: '/v5/apply/p0',
    method: 'get',
    params:{
      ...params
    }
  })
}


// p0进件
export const applyp0list = (params) => {
  return request({
    url: '/v5/apply/list',
    method: 'get',
    params:{
      ...params
    }
  })
}


// 速贷进件
export const  applysudai = (params) => {
  return request({
    url: '/v5/apply/sudai',
    method: 'get',
    params:{
      ...params
    }
  })
}

// P2进件
export const  applyp2 = (params) => {
  return request({
    url: '/v5/apply/p2',
    method: 'get',
    params
  })
}

// P4进件
export const  applyp4 = (params) => {
  return request({
    url: '/v5/apply/p4',
    method: 'get',
    params:{
      ...params
    }
  })
}



// 联登车贷
export const  unionlogin = (params) => {
  return request({
    url: '/v5/union/login',
    method: 'get',
    params:{
      ...params
    }
  })
}

// 联登车贷
export const  p0Agreement = () => {
  return request({
    url: '/v5/Agreement/agreement',
    method: 'get',

  })
}

// 查询用户信息
export const  userInfoShow = () => {
  return request({
    url: '/v5/userInfo/show',
    method: 'get',

  })
}




// *p0待授信列表
export const  applyprelist = (params) => {
  return request({
    url: '/v5/apply/prelist',
    method: 'get',
    params:{
      ...params
    }
  })
}


// *p0授信状态查询
export const  applyquerystatus = (apply_order_no) => {
  return request({
    url: '/v5/apply/querystatus',
    method: 'get',
    params:{
      apply_order_no:apply_order_no
    }
  })
}


// *p0授信状态查询
export const  applyclick = (params) => {
  return request({
    url: '/v5/apply/click',
    method: 'get',
    params:{
     ...params
    }
  })
}



// *p0授信状态查询
export const  applyinglist2 = (params) => {
  return request({
    url: '/v5/apply/list2',
    method: 'get',
    params:{
      ...params
    }
  })
}


// 获取借款链接
export const  getLoanUrl = (params) => {
  return request({
    url: '/rocket/loan/getLoanUrl',
    method: 'get',
    params:{
      ...params
    }
  })
}


// 获取天下信用链接
export const  gettxxuUrl = (params) => {
  return request({
    url: '/v5/userInfo/txxyUrl',
    method: 'get',
    params:{
      ...params
    }
  })
}

// APP渠道产品协议(产品配置渠道黑白名单)
export const  channelAgreement = (product) => {
  return request({
    url: `/oapi/protocol/app/ch/${product}`,
    method: 'get',
    params:{
      _channel:product
    }
  })
}


// 联登好融
export const loginMarkCode = (markcode) => {
  return request({
    url: '/v5/userAuth/loginMarkCode',
    method: 'get',
    params: {
      markcode: markcode
    }
  })
}

// 渠道信息
export const channelInfoForm = () => {
  return request({
    url: '/v5/channel/info',
    method: 'get',
    params: {}
  })
}








// WEBPACK FOOTER //
// ./src/api/version3/version3.js